import { connect, ConnectedProps } from "react-redux";
import { PickerType } from "halifax";

import { withRouter } from "react-router";
import { MonthAndDatePicker } from "./component";
import { IStoreState } from "../../../../../../reducers/types";
import {
  getCalendarPriceMonths,
  getCalendarPriceRangeLegends,
  getFetchCalendarPriceBucketsCallState,
  getLocation,
} from "../../../../reducer";

const mapStateToProps = (state: IStoreState) => ({
  pickerType: PickerType.RANGE,
  priceTags: getCalendarPriceRangeLegends(state),
  months: getCalendarPriceMonths(state),
  priceBucketsCallState: getFetchCalendarPriceBucketsCallState(state),
  searchLocation: getLocation(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MonthAndDatePickerConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedMonthAndDatePicker = withRouter(
  connector(MonthAndDatePicker)
);
